import { getUser } from '..';

export const isAdminUser = (): boolean => {
    const user = getUser();
    return user.data?.isAdmin || false;
};
